import { gql } from '@apollo/client';

export const COMPANY_FEATURE_OPT_IN = gql`
  mutation CompanyFeatureOptIn($feature: String!) {
    companyFeatureOptIn(input: { feature: $feature }) {
      errors {
        error
        message
        path
      }
      success
    }
  }
`;
